/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type { ErrorType } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type {
	ContentFeedItemDto,
	GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	GetUmbracoDeliveryApiV2SubmenuParams,
	SubmenuResponseDto,
} from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getUmbracoDeliveryApiV2ContentFeedContentId = (
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ContentFeedItemDto[]>(
		{
			url: `/umbraco/delivery/api/v2/content-feed/${contentId}`,
			method: "GET",
			params,
			signal,
		},
		options,
	);
};

export const getGetUmbracoDeliveryApiV2ContentFeedContentIdQueryKey = (
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
) => {
	return [
		`/umbraco/delivery/api/v2/content-feed/${contentId}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetUmbracoDeliveryApiV2ContentFeedContentIdQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetUmbracoDeliveryApiV2ContentFeedContentIdQueryKey(contentId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2ContentFeedContentId(
			contentId,
			params,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: contentId !== null && contentId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2ContentFeedContentIdQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>
	>;
export type GetUmbracoDeliveryApiV2ContentFeedContentIdQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2ContentFeedContentId<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params: undefined | GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentFeedContentId<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
					>,
					TError,
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
					>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentFeedContentId<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2ContentFeedContentId<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2ContentFeedContentIdQueryOptions(
			contentId,
			params,
			options,
		);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoDeliveryApiV2ContentFeedContentIdSuspenseQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
		>,
		TError = ErrorType<void>,
	>(
		contentId: string,
		params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
		options?: {
			query?: Partial<
				UseSuspenseQueryOptions<
					Awaited<
						ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		},
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetUmbracoDeliveryApiV2ContentFeedContentIdQueryKey(contentId, params);

		const queryFn: QueryFunction<
			Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>
		> = ({ signal }) =>
			getUmbracoDeliveryApiV2ContentFeedContentId(
				contentId,
				params,
				requestOptions,
				signal,
			);

		return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetUmbracoDeliveryApiV2ContentFeedContentIdSuspenseQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>
	>;
export type GetUmbracoDeliveryApiV2ContentFeedContentIdSuspenseQueryError =
	ErrorType<void>;

export function useGetUmbracoDeliveryApiV2ContentFeedContentIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params: undefined | GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentFeedContentIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2ContentFeedContentIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2ContentFeedContentIdSuspense<
	TData = Awaited<
		ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>
	>,
	TError = ErrorType<void>,
>(
	contentId: string,
	params?: GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2ContentFeedContentId>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoDeliveryApiV2ContentFeedContentIdSuspenseQueryOptions(
			contentId,
			params,
			options,
		);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const getUmbracoDeliveryApiV2Submenu = (
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<SubmenuResponseDto>(
		{ url: `/umbraco/delivery/api/v2/submenu`, method: "GET", params, signal },
		options,
	);
};

export const getGetUmbracoDeliveryApiV2SubmenuQueryKey = (
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
) => {
	return [
		`/umbraco/delivery/api/v2/submenu`,
		...(params ? [params] : []),
	] as const;
};

export const getGetUmbracoDeliveryApiV2SubmenuQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoDeliveryApiV2SubmenuQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2Submenu(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2SubmenuQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
>;
export type GetUmbracoDeliveryApiV2SubmenuQueryError = ErrorType<void>;

export function useGetUmbracoDeliveryApiV2Submenu<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2SubmenuParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2Submenu<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2Submenu<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2Submenu<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetUmbracoDeliveryApiV2SubmenuQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoDeliveryApiV2SubmenuSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoDeliveryApiV2SubmenuQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
	> = ({ signal }) =>
		getUmbracoDeliveryApiV2Submenu(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoDeliveryApiV2SubmenuSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>
>;
export type GetUmbracoDeliveryApiV2SubmenuSuspenseQueryError = ErrorType<void>;

export function useGetUmbracoDeliveryApiV2SubmenuSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params: undefined | GetUmbracoDeliveryApiV2SubmenuParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SubmenuSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoDeliveryApiV2SubmenuSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoDeliveryApiV2SubmenuSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
	TError = ErrorType<void>,
>(
	params?: GetUmbracoDeliveryApiV2SubmenuParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoDeliveryApiV2Submenu>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetUmbracoDeliveryApiV2SubmenuSuspenseQueryOptions(
		params,
		options,
	);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}
